import * as React from "react";
import {Table} from "semantic-ui-react";

interface ICategorySortTableHeaderProps {
    t: reactI18Next.TranslationFunction;
}

export const CategorySortTableHeader: React.SFC<ICategorySortTableHeaderProps> = (props: ICategorySortTableHeaderProps) => {
    return (
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>{props.t("CATEGORY_SORT:CATEGORY_CODE")}</Table.HeaderCell>
                <Table.HeaderCell>{props.t("CATEGORY_SORT:CATEGORY_TEXT_DE")}</Table.HeaderCell>
                <Table.HeaderCell>{props.t("CATEGORY_SORT:CATEGORY_TEXT_EN")}</Table.HeaderCell>
                <Table.HeaderCell>{props.t("CATEGORY_SORT:PCCD_SEQUENCE")}</Table.HeaderCell>
                <Table.HeaderCell>{props.t("CATEGORY_SORT:PROMT_SEQUENCE")}</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
    );
};



// WEBPACK FOOTER //
// ./src/views/AdminView/CategorySortTab/CategorySortTableHeader.tsx